// libs
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Styles
import './styles.scss';

// Components
import NewsletterForm from '../../../../layouts/newsletter/NewsletterForm';
import SocialShare from '../../../../tools/share/SocialShare';

// Props and Context
const propTypes = {
  activity: PropTypes.object.isRequired,
};

const defaultProps = {};

const contextTypes = {
  t: PropTypes.func,
};

function RecommendationModal(props, { t }) {
  const {
    activity: {
      recommendationsModal = {},
    },
  } = props;
  return (
    <div>
      <div className="modal__title">
        <span>
          {recommendationsModal.title}
        </span>
      </div>
      <div className="modal__text">
        {recommendationsModal.text}
      </div>
      <div className="modal__newsletter">
        {
          // TO-DO: include mailchimp form
        }
        <div className="newsletter newsletter--light">
          <NewsletterForm />
        </div>
      </div>
      <div className="modal__share">
        <span className="modal__share__label">
          {t('pages.activity.shareActivity')}
        </span>
        <SocialShare {...props} />
      </div>
    </div>
  );
}

RecommendationModal.contextTypes = contextTypes;
RecommendationModal.propTypes = propTypes;
RecommendationModal.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    activity: state.activity.postData,
  };
}

export default connect(mapStateToProps)(RecommendationModal);



// WEBPACK FOOTER //
// ./src/app/components/singles/activity/parts/recommendationModal/recommendationModal.js